/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentStanding = {
    properties: {
        points: {
            type: 'number',
            isRequired: true,
        },
        goalsIn: {
            type: 'number',
            isRequired: true,
        },
        goalsOut: {
            type: 'number',
            isRequired: true,
        },
        matchesPlayed: {
            type: 'number',
            isRequired: true,
        },
        wins: {
            type: 'number',
            isRequired: true,
        },
        draws: {
            type: 'number',
            isRequired: true,
        },
        losses: {
            type: 'number',
            isRequired: true,
        },
        placement: {
            type: 'number',
            isRequired: true,
        },
        team: {
            type: 'TeamSmall',
            isRequired: true,
        },
    },
} as const;
